module.exports = __webpack_public_path__ + "static/media/video_reactangle_icon_big.f0721a2e.svg";